export const en = {
  notFound:{
    ups: "Ups...",
    doesntExist: "You’ve found a meeting room that doesn’t exist.",
    itsYours: "Now it's yours!",
    meanwhile: "Meanwhile...",
    buttonMessage: "Go to Dashboard"
  }
}